import * as React from 'react';
import { useHistory } from 'react-router';
import axios from 'axios';
import PageContent from '../../components/layout/PageContent';
import CustomForm from '../../components/form/CustomForm';
import { handleFormImageUpload } from '../../utils';

const AddSchool = () => {

	const [ fields, setFields ] = React.useState([]);

	const history = useHistory();

	React.useEffect(() => {
		axios.get(`/api/school`)
		.then(({ data = {} }) => {
			const { result = [] } = data;
			setFields(result);
		})
		.catch(err => {
			console.log(err);
		})
	}, []);

	const handleSubmit = values => {
		axios.post(`/api/school`, values)
		.then(({ data }) => {
			if (data.statusCode === 200) {
				history.push('/school');
			}
		})
		.catch(err => {
			console.log(err);
		})
	}

	const handleCancel = () => {
		history.push('/school')
	}

	return (
		<PageContent 
			background='#fff'
			subheader={{
				title: 'Сургууль үүсгэх',
				background: '#ffffff'
			}}
		>
			<CustomForm
				fields={fields}
				onSubmit={handleSubmit}
				onCancel={handleCancel}
				imageUpload={handleFormImageUpload}
			/>
		</PageContent>
	)
}

export default AddSchool;